module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.fe4a1ef.eot";